import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const Freshfruit = () => {
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategories = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/category_list`,
      );

      if (data?.result) {
        setCategoryList(data.data);
      } else {
        setError("No categories found");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryClick = (id) => {
    if (!id) return;
    secureLocalStorage.setItem("n_sub_category_list_id", id);
    navigate("/shopscategory");
  };

  if (loading)
    return (
      <div
        className="loading"
        style={{
          textAlign: "center",
          padding: "4rem",
          backgroundColor: "#fef9e7",
        }}
      >
        <div
          className="spinner"
          style={{
            width: "40px",
            height: "40px",
            border: "3px solid #f0f0f0",
            borderTopColor: "#160015",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 1rem",
          }}
        ></div>
        <p style={{ color: "#160015", fontWeight: "500" }}>Loading...</p>

        <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      </div>
    );

  if (error)
    return (
      <div className="error" style={{ textAlign: "center", padding: "4rem" }}>
        <p
          style={{ color: "#160015", marginBottom: "1rem", fontWeight: "500" }}
        >
          {error}
        </p>
        <button
          onClick={fetchCategories}
          style={{
            padding: "0.5rem 1.5rem",
            background: "#160015",
            color: "#fee894",
            border: "2px solid #160015",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "0.9rem",
            fontWeight: "600",
            transition: "all 0.2s",
          }}
          onMouseOver={(e) => {
            e.target.style.background = "#fee894";
            e.target.style.color = "#160015";
          }}
          onMouseOut={(e) => {
            e.target.style.background = "#160015";
            e.target.style.color = "#fee894";
          }}
        >
          Retry
        </button>
      </div>
    );

  return (
    <section
      className="categories"
      
    >
      <div className="container-fluid">
        <h2
          style={{
            fontSize: "1.75rem",
            fontWeight: "600",
            color: "#160015",
            marginBottom: "2rem",
            textAlign: "center",
          }}
        >
          Top Categories
        </h2>

        <div
          className="grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "1.5rem",
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {categoryList.map((item) => (
            <div
              className="card"
              key={item._id}
              onClick={() => handleCategoryClick(item._id)}
              style={{
                cursor: "pointer",
                textAlign: "center",
                transition: "transform 0.2s, border-color 0.2s",
                padding: "0.7rem",
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "2px solid #160015",
                boxShadow: "0 4px 12px rgba(22, 0, 21, 0.1)",
              }}
            >
              <img
                src={`${process.env.REACT_APP_API}uploads/${item.category_image}`}
                alt={item.category_name}
                onError={(e) => (e.target.src = "/no-image-placeholder.jpg")}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "50%",
                  margin: "0 auto 10px",
                }}
              />
              <h3
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: "#160015",
                  margin: "0",
                }}
              >
                {item.category_name}
              </h3>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .card:hover {
          transform: translateY(-5px);
          border-color: #fee894;
          box-shadow: 0 8px 20px rgba(22, 0, 21, 0.15);
        }

        /* Responsive */
        @media (max-width: 992px) {
          .grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }

        @media (max-width: 768px) {
          .grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 0.75rem !important;
          }

          .card {
            width: 100% !important;
          }

          .card img {
            width: 60px !important;
            height: 60px !important;
          }

          h2 {
            font-size: 0.85rem !important;
          }
        }

        @media (max-width: 480px) {
          .grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 0.75rem !important;
          }

          .card img {
            width: 60px !important;
            height: 60px !important;
            
          }

          .card h3 {
            font-size: 0.7rem !important;
          }
        }

        @media (max-width: 360px) {
          .grid {
            grid-template-columns: 1fr !important;
          }

          .categories {
            padding: 2rem 0.5rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Freshfruit;
